import React from "react";
import { useLocation } from "react-router-dom";
import useAuthStore from "../../store/authStore";
import LandingPageRedirect from "./LandingPageRedirect";

export const litigationFeatures = {
  LITIGATION_CASE: {
    key: "litigation_case",
    route: "/litigation/case",
  },
  LITIGATION_CREATE_CASE: {
    key: "litigation_create_case",
    route: "/litigation/create-case",
  },
  LITIGATION_BATCH: {
    key: "litigation_batch",
    route: "/litigation/batch",
  },
};

export const litigationFeaturesArr = Object.values(litigationFeatures);

const isRouteDisabled = (route, allowed = []) => {
  const currentRouteDetails = litigationFeaturesArr.find((el) => el?.route === route);
  return !!currentRouteDetails && !allowed.includes(currentRouteDetails.key);
};

export default function ControlledNavigation({ component: Component }) {
  const features = useAuthStore((state) => state.features);
  const location = useLocation();

  if (isRouteDisabled(location.pathname, features || [])) {
    return <LandingPageRedirect />;
  }

  return <Component />;
}
